export const extraNoteRenderers = {
  industry: value => value?.industry?.title,
  location: value => `${value?.address?.city?.state?.title}, ${value?.address?.city?.state?.slug} `
};
